import React, { useState } from 'react'
import { Label } from 'reactstrap'
import Conditions from '../Conditions'

const ConditionsCheckBox = ({
  checkbox,
  setCheckbox,
  basvuru_sartlari_title,
  basvuru_sartlari_aciklama,
  style = {},
  kisa_metin = 'Yanıbaşımda Karatay eğitim yardımı sözleşmesini, kullanım koşullarını ve K.V.K.K. metnini okudum, kabul ettim.',
}) => {
  const [modal, setModal] = useState(false)
  const toggleSartlar = (e) => {
    e.stopPropagation()
    setModal(!modal)
  }

  return (
    <div
      className='d-flex'
      style={
        style
          ? { ...style }
          : {
              display: 'flex',
              justifyContent: 'flex-start',
              marginTop: '1rem',
              marginLeft: '1rem',
              marginRight: '1rem',
            }
      }
    >
      <div className='inputContainer'>
        <input
          style={{
            minWidth: '1rem',
            minHeight: '1rem',
            maxWidth: '1.3rem',
            maxHeight: '1.3rem',
          }}
          type='checkbox'
          value={checkbox}
          checked={checkbox}
          onChange={() => {
            if (checkbox) {
              setCheckbox(false)
            } else {
              setCheckbox(true)
            }
          }}
        />
      </div>
      <Label
        style={{
          fontSize: '0.7rem',
          marginLeft: '0.6rem',
          color: '#285843',
        }}
        onClick={toggleSartlar}
      >
        {kisa_metin}
      </Label>
      <Conditions toggle={toggleSartlar} modal={modal} basvuruSartlariTitle={basvuru_sartlari_title} basvuru_sartlari_aciklama={basvuru_sartlari_aciklama} />
    </div>
  )
}

export default ConditionsCheckBox
